import type { SVGProps } from 'react';

/**
 * Lifebuoy (support/help) icon for the qualified message's help callout. Local to the form
 * messages because it is not used anywhere else — the shared `pages/icons.tsx` stays reserved
 * for icons with cross-component reuse.
 */
export const Lifebuoy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="10" cy="10" r="7.5" />
    <circle cx="10" cy="10" r="3.125" />
    <line x1="7.79" y1="7.79" x2="4.7" y2="4.7" />
    <line x1="12.21" y1="7.79" x2="15.3" y2="4.7" />
    <line x1="12.21" y1="12.21" x2="15.3" y2="15.3" />
    <line x1="7.79" y1="12.21" x2="4.7" y2="15.3" />
  </svg>
);
